export default __webpack_public_path__ + "static/media/plus.ca57d4ba.svg";